import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'

// Results: print compact PDF
export const resultsPdfPrintCompact = (e) => {
  let mainContent = document.getElementById("main-content")
  let element = mainContent.querySelector('.inner')

  element.scrollTo(0, 0)
  
  let positionInfo = element.getBoundingClientRect()
  let divHeight = positionInfo.height
  let divWidth = positionInfo.width
  let ratio = divHeight / divWidth

  let pdf = new jsPDF('l', 'px', 'a4')

  html2canvas(element)
    .then((canvas) => {
      const imgData = canvas.toDataURL('image/jpeg')
      let docWidth = pdf.internal.pageSize.width
      let imgHeight = ratio * docWidth

      pdf.addImage(imgData, 'JPEG', 0, 20, docWidth, imgHeight)
      pdf.save("resultaat-compact.pdf")
  })
}

// Results: print extended PDF
export const resultsPdfPrintExtended = (e) => {
  let pdf = new jsPDF('l', 'px', 'a4')

  let mainContent = document.getElementById("main-content")
  let source = mainContent.querySelector('.print-pdf')

  let specialElementHandlers = {
    '#bypassme': function(element, renderer) {
      return true
    }
  }

  let margins = {
    top: 20,
    bottom: 20,
    left: 20,
    width: 545
  }

  pdf.fromHTML (
    source, // HTML string or DOM elem ref.
    margins.left, // x coord
    margins.top, // y coord
    {
      'width': margins.width, // max width of content on PDF
      'elementHandlers': specialElementHandlers,
      pagesplit: true
    },
    function (dispose) {
      // dispose: object with X, Y of the last line add to the PDF
      // this allow the insertion of new lines after html
      pdf.save('resultaat-uitgebreid.pdf');
    },
    margins
  )
}

// Results: print consultation PDF
export const resultsPdfPrintConsultations = (e) => {
  let pdf = new jsPDF('l', 'px', 'a4')

  let mainContent = document.getElementById("main-content")
  let source = mainContent.querySelector('.feedback-exquestions')

  let specialElementHandlers = {
    '#bypassme': function(element, renderer) {
      return true
    }
  }

  let margins = {
    top: 20,
    bottom: 20,
    left: 20,
    width: 545
  }

  pdf.fromHTML (
    source, // HTML string or DOM elem ref.
    margins.left, // x coord
    margins.top, // y coord
    {
      'width': margins.width, // max width of content on PDF
      'elementHandlers': specialElementHandlers,
      pagesplit: true
    },
    function (dispose) {
      // dispose: object with X, Y of the last line add to the PDF
      // this allow the insertion of new lines after html
      pdf.save('raadpleging-uitkomsten.pdf');
    },
    margins
  )
}

// Analysis: print extended PDF
export const analysisPdfPrintExtended = (e) => {
  let pdf = new jsPDF('l', 'px', 'a4')

  let mainContent = document.getElementById("main-content")
  let source = mainContent.querySelector('.print-pdf')

  let specialElementHandlers = {
    '#bypassme': function(element, renderer) {
      return true
    }
  }

  let margins = {
    top: 20,
    bottom: 20,
    left: 20,
    width: 545
  }

  pdf.fromHTML (
    source, // HTML string or DOM elem ref.
    margins.left, // x coord
    margins.top, // y coord
    {
      'width': margins.width, // max width of content on PDF
      'elementHandlers': specialElementHandlers,
      pagesplit: true
    },
    function (dispose) {
      // dispose: object with X, Y of the last line add to the PDF
      // this allow the insertion of new lines after html
      pdf.save('analyse-uitgebreid.pdf');
    },
    margins
  )
}


// WEBPACK FOOTER //
// ./src/utils/pdf.js